import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export const vuetify = new Vuetify({
  breakpoint: {
    thresholds: {
      xxs: 300,
      xs: 600,
      sm: 800,
      md: 1000,
      xl: 1200
    }
  },
  theme: {
    themes: {
      light: {
        primary: '#4b91ac',
        secondary: '#F5F5F5',
        accent: '#e0f7fa',
        error: '#f44336',
        warning: '#ffeb3b',
        info: '#2196f3',
        success: '#689F38',
        multiselect: '#E1DED4',
        expand: '#2EA9B7',
        'tapper-retry': '#ECECEC',
        third: '#4b91ac',
        orange: "d96a37",
        severe: "#DB322D",
        moderate: "#FFC300",
        mild: "#83D4A3",
        none: "#83D4A3",
        possible: "#2196f3",
      },
      dark: {
        primary: '#06191E',
        blacktonebackground: '#9cbec0',
        secondary: '#FFFFFF',
        accent: '#e0f7fa',
        error: '#FF4545',
        info: '#2196f3',
        multiselect: '#FFFFFF',
        cardlight: '#FFFFFF',
        carddark: '#06191E',
        expand: '#2EA9B7',
        'tapper-retry': '#ECECEC',
        third: '#4b91ac',
        orange: "#d96a37",
        severe: "#DB322D",
        moderate: "#FFBF00",
        mild: "#83D4A3",
        none: "#83D4A3",
        possible: "#2196f3",
        danger: "#FF4545",
        warning: '#FF8223',
        caution: '#FFBF00',
        success: '#26AD32',
        deepblue: '#06191E',
        primaryblue: '#003644',
        primaryblue30: '#B2C2C6',
        primaryblue10: '#E3E8EA',
        blue: '#559CB4',
        lightblue: '#A4DFF2',
        mint: '#239C9B',
        lime: '#8DECD7',
        lemon: '#E0F0AF',
        peach: '#EDC2AA',
        beige: '#E2DDCB',
        lightgreen: '#75E6C1',
        vibrantlightblue: '#11CEFF',
        footerblue: '#002029'
      }
    },
    dark: true
  },
  scrollbarWidth: 10,
  icons: {
    iconfont: 'mdiSvg',
  },
});
